import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const Hamburger = ({ open, className, ...otherProps }) => (
  <div
    {...otherProps}
    className={classNames('hamburger', className, {
      selected: open,
    })}
  />
);

Hamburger.propTypes = {
  open: PropTypes.bool.isRequired,
  className: PropTypes.string,
};
